import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "kis_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      clearToken();
      if (!window.location.pathname.startsWith("/admin/login")) window.location.assign("/admin/login");
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
};

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong.";
};

export const can = (role, section) => {
  const map = {
    dashboard: ["super_admin", "content_admin", "inquiry_manager"],
    inquiries: ["super_admin", "inquiry_manager"],
    subscribers: ["super_admin", "inquiry_manager"],
    offers: ["super_admin", "content_admin"],
    content: ["super_admin", "content_admin"],
    gallery: ["super_admin", "content_admin"],
    faqs: ["super_admin", "content_admin"],
    analytics: ["super_admin", "content_admin", "inquiry_manager"],
    users: ["super_admin"],
    activity: ["super_admin"],
  };
  return (map[section] || []).includes(role);
};
